import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class UzvivatelskaPrava extends BaseApi {
	getPracovnikPrava(pracovnikId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPracovnikPrava`, { pracovnikId });
	}

	saveUserPermissions(pracovnikId: number, data: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SaveUserPermissions?userId=${pracovnikId}`, data);
	}

	async getDiscountLimitConfig(PracovnikId: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetDiscountLimitConfig`, { PracovnikId });
	}

	async saveDiscountLimitConfig(dto:any) {
		return this.post(`/${DMS_MODULE}/${NAME}/saveDiscountLimitConfig`, dto);
	}

	async setOneTimePassword(pracovnikId: number | null, password: string) {
		return this.post(`/${DMS_MODULE}/${NAME}/JednorazoveHeslo?pracovnikId=${pracovnikId}&heslo=${password}`);
	}

	isUserUniqueLoginName(zaznamId: number | null, loginName: null | string, workerId: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsLoginNameUnique?zaznamId=${zaznamId}&loginName=${loginName}&workerId=${workerId}`);
	}
}
export const apiProvider = new UzvivatelskaPrava(DMS_MODULE, NAME);
